import {DynFieldData} from '.';
import {DynForm} from '../meta/dyn-form';

export class DynSimpleFieldData extends DynFieldData {

    public type = 'simple';

    public static toEntity(json: any, form: DynForm): DynSimpleFieldData {
        const field = new DynSimpleFieldData();
        field.setId( json.id );
        field.setType( json.type );
        field.setField( form.getFieldByName(json.field.name) );
        field.setValue( json.value );
        field.setObservations( json.observations );
        return field;
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/data/dyn-simple-field-data.ts